import { render, staticRenderFns } from "./RequestChatPage.vue?vue&type=template&id=085af03a&scoped=true"
import script from "./RequestChatPage.vue?vue&type=script&lang=js"
export * from "./RequestChatPage.vue?vue&type=script&lang=js"
import style0 from "./RequestChatPage.vue?vue&type=style&index=0&id=085af03a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085af03a",
  null
  
)

export default component.exports